export function formatSupportDateTime(value: string, locale = 'es-PE'): string {
  return new Date(value).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatSupportCalendarDate(
  value: string,
  locale = 'es-PE'
): string {
  return new Date(`${value}T00:00:00Z`).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
